import React from "react";
import styled from "styled-components";
import {
  GlobalStyle,
  Logo,
  MainContent,
  PageContainer,
  Sidebar,
  Title
} from "./BetaComponents";
import VectorMan from "./VectorMan";

const StyledVectorMan = styled(VectorMan)`
  max-width: 500px;
  width: 100%;
  height: auto;
  margin-bottom: 24px;
`;

const PageNotFoundPage = () => {
  return (
    <>
      <GlobalStyle />
      <PageContainer>
        <Sidebar>
          <Logo />
        </Sidebar>
        <MainContent>
          <StyledVectorMan/>
          <Title>
            We're sorry, but the page you are looking for could not be found.
          </Title>
        </MainContent>
      </PageContainer>
    </>
  );
};

export default PageNotFoundPage;
